import type { GetArAgingReportResponse } from '@weft/api-definition';
import type { ItemOf } from '@weft/utils';
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import { AR_AGING_REPORT_TABLE_COLUMNS } from './ArAgingReportTableColumns';

export const ArAgingReportTable: React.FC<VyTableMinimalProps<ItemOf<GetArAgingReportResponse['summary']>>> = ({ items, itemsCount, loadingItems, ...props }) => {
  return (
    <VyTable
      itemsCount={itemsCount}
      items={items}
      columns={AR_AGING_REPORT_TABLE_COLUMNS}
      loadingItems={loadingItems}
      getRowId={() => crypto.randomUUID()}
      {...props}
    />
  );
};